<template>
    <section>
        <Header title="Dashboard"></Header>
        <v-container class="dashboard-container">
            <p v-if="isLoading" class="text-center my-7"><v-icon large color="primary">fal fa-spinner-third fa-spin</v-icon></p>
            <template v-if="!isLoading && (!isLoggedIn || mainFacet)">
                <div class="dashboard-welcome">
                    <div class="dashboard-welcome-content">
                        <h1 class="dashboard-welcome-title">Welkom{{ user && user.name ? `, ${user.name}` : '' }}!</h1>
                        <p v-if="showMobilityPortal" class="dashboard-welcome-text">Waar ben je vandaag naar op zoek? Kies hieronder een van de portalen.</p>
                        <p v-else class="dashboard-welcome-text">Waar ben je vandaag naar op zoek? Bekijk hieronder het beschikbare dienstenaanbod.</p>
                    </div>
                    <img src="/img/dashboard-welkom.png" alt="" class="dashboard-welcome-illustration d-none d-md-block">
                </div>
                <v-row justify="center">
                    <v-col v-if="showMobilityPortal" cols="12" lg="6">
                        <v-card class="portal-card elevation-0">
                            <v-card-text>
                                <div class="portal-card-header">
                                    <span class="portal-card-icon"><v-icon>fal fa-users</v-icon></span>
                                    <div>
                                        <h2 class="portal-card-title">Mobiliteitsportaal</h2>
                                        <p class="portal-card-subtitle">Beschikbare kandidaten</p>
                                    </div>
                                </div>
                                <p class="portal-card-description">
                                    Bekijk per functiecategorie welke kandidaten in de regio beschikbaar zijn
                                    en kom vrijblijvend met ze in contact.
                                </p>
                                <div class="portal-actions">
                                    <v-btn
                                        v-for="choice in mainFacet.choices" :key="choice.id" @click="openMainFacetChoice(choice)"
                                        color="white" block rounded class="portal-action-btn mb-3 elevation-0"
                                    >
                                        <span class="portal-action-icon">
                                            <v-icon small>fal fa-user</v-icon>
                                        </span>
                                        {{ choice.value }}
                                        <span v-if="profileCountForChoice(choice) > 0" class="portal-action-count">
                                            {{ profileCountForChoice(choice) }}
                                        </span>
                                        <v-icon small class="portal-action-chevron">fal fa-chevron-right</v-icon>
                                    </v-btn>
                                </div>
                                <div class="portal-card-footer">
                                    <v-btn text dark small class="portal-card-footer-btn" :to="{ name: 'Profiles' }">
                                        Bekijk alle kandidaten <v-icon x-small right>fal fa-arrow-right</v-icon>
                                    </v-btn>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <!-- Zonder mobiliteitsportaal (publieke bezoekers) krijgt het dienstenblok wat meer ruimte. -->
                    <v-col cols="12" :lg="showMobilityPortal ? 6 : 8">
                        <v-card class="portal-card elevation-0">
                            <v-card-text>
                                <div class="portal-card-header">
                                    <span class="portal-card-icon"><v-icon>fal fa-building</v-icon></span>
                                    <div>
                                        <h2 class="portal-card-title">Dienstenportaal</h2>
                                        <p class="portal-card-subtitle">Beschikbare diensten en activiteiten</p>
                                    </div>
                                </div>
                                <p class="portal-card-description">
                                    Ontdek het diensten- en activiteitenaanbod van aangesloten dienstverleners,
                                    van startersbegeleiding tot professionalisering en duurzame inzetbaarheid.
                                </p>
                                <div class="portal-actions">
                                    <v-btn
                                        @click="openOrganisations('starters')"
                                        color="white" block rounded class="portal-action-btn mb-3 elevation-0"
                                    >
                                        <span class="portal-action-icon">
                                            <v-icon small>fal fa-seedling</v-icon>
                                        </span>
                                        Begeleiding voor starters
                                        <span v-if="organisationCountForType('starters') > 0" class="portal-action-count">
                                            {{ organisationCountForType('starters') }}
                                        </span>
                                        <v-icon small class="portal-action-chevron">fal fa-chevron-right</v-icon>
                                    </v-btn>
                                    <v-btn
                                        @click="openOrganisations('professional_sustainable')"
                                        color="white" block rounded class="portal-action-btn mb-3 elevation-0"
                                    >
                                        <span class="portal-action-icon">
                                            <v-icon small>fal fa-graduation-cap</v-icon>
                                        </span>
                                        Professionalisering / duurzame inzetbaarheid
                                        <span v-if="organisationCountForType('professional_sustainable') > 0" class="portal-action-count">
                                            {{ organisationCountForType('professional_sustainable') }}
                                        </span>
                                        <v-icon small class="portal-action-chevron">fal fa-chevron-right</v-icon>
                                    </v-btn>
                                </div>
                                <div class="portal-card-footer">
                                    <v-btn text dark small class="portal-card-footer-btn" :to="{ name: 'Organisations' }">
                                        Bekijk het volledige aanbod <v-icon x-small right>fal fa-arrow-right</v-icon>
                                    </v-btn>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </template>
            <v-alert v-if="!isLoading && isLoggedIn && !mainFacet" color="warning">
                <v-icon class="mr-3">fal fa-exclamation-triangle</v-icon> Controleer uw internetverbinding en/of probeer het later opnieuw.
            </v-alert>
        </v-container>
    </section>
</template>

<script>
import Header from "@/components/layout/Header";
import {mapState} from "vuex";

export default {
    name: 'Home',
    components: {
        Header,
    },
    data: () => ({
        isLoading: true,
    }),
    computed: {
        mainFacet () {
            // Functiecategorieën
            return this.facets.find(facet => facet.id === 1);
        },
        ...mapState({
            facets: state => state.profile.facets,
            profiles: state => state.profile.profiles,
            organisations: state => state.organisation.organisations,
            isLoggedIn: state => state.auth.isLoggedIn,
            user: state => state.auth.user,
        }),
        isManager () {
            return this.user && this.user.role === 'manager';
        },
        showMobilityPortal () {
            // Het mobiliteitsportaal is alleen zichtbaar voor ingelogde managers;
            // publieke bezoekers (via "Bekijk diensten") zien enkel het dienstenportaal.
            return this.isManager && !!this.mainFacet;
        },
    },
    mounted () {
        // Alleen nodig voor de aantallen op de dienstenknoppen; het aanbod is publiek,
        // dus dit werkt ook zonder login. Als het ophalen mislukt blijven de aantallen
        // simpelweg verborgen.
        this.$store.dispatch('organisation/updateOrganisations')
            .catch(e => console.error(e));

        if (!this.isLoggedIn) {
            this.isLoading = false;
            return;
        }

        this.$store.dispatch('updateProfiles')
            .catch(e => {
                console.error(e);

                // Bij een 401 is de sessie verlopen; de api-client logt uit en
                // stuurt door naar het inlogscherm. Daar hoort geen foutmelding bij.
                if (e.response && e.response.status === 401) {
                    return;
                }

                return this.$store.dispatch('showSnackbar', {
                    color: 'error',
                    text: 'Profielen konden niet worden opgehaald'
                });
            })
            .finally(() => {
                this.isLoading = false;
            });
    },
    methods: {
        openMainFacetChoice (facetChoice) {
            let query = {};
            query['filter'+this.mainFacet.id] = facetChoice.id;
            this.$router.push({name: 'Profiles', query: query});
        },
        openOrganisations (type) {
            this.$router.push({name: 'Organisations', query: { type }});
        },
        profileCountForChoice (choice) {
            return this.profiles.filter(profile => (profile.facetChoices || []).some(c => c.id === choice.id)).length;
        },
        organisationCountForType (type) {
            // Zelfde mapping als in de organisation-store: de gecombineerde knop
            // telt beide onderliggende types mee.
            const wantedTypes = type === 'professional_sustainable'
                ? ['professional', 'sustainable_employability']
                : [type];

            return this.organisations.filter(organisation => wantedTypes.includes(organisation.organisationType)).length;
        },
    },
}
</script>
